// extracted by mini-css-extract-plugin
export var actionText = "_n6-4";
export var container = "_n6-0";
export var leftSection = "_n6-1";
export var rightSection = "_n6-2";
export var settingsButton = "_n6-6";
export var settingsIcon = "_n6-7";
export var shortcut = "_n6-5";
export var shortcutGroup = "_n6-3";